module.exports = __webpack_public_path__ + "static/img/dyh.8566a398.jpg";